/**
 * Lightweight module-level store that shares camera orientation between
 * the R3F Canvas (CameraController) and DOM-level keyboard handlers.
 *
 * CameraController computes the directions and writes them here.
 * useArrowKeyMovement reads them to move lamps relative to the camera view.
 */

let forward: [number, number] = [-0.7071, -0.7071];
let right: [number, number] = [-0.7071, 0.7071];

/** Store pre-computed directions (called by CameraController). */
export function setDirections(fwd: [number, number], rgt: [number, number]) {
  forward = fwd;
  right = rgt;
}

/** Direction from camera toward target on XY plane (unit vector). */
export function getForward(): [number, number] {
  return forward;
}

/** 90° right of forward on XY plane (unit vector). */
export function getRight(): [number, number] {
  return right;
}
